<template>
	<v-banner v-if="showBanner" color="warning" dark sticky icon="mdi-alert" class="service-banner">
		<span class="service-banner__message">
			{{ $t("serviceBanner.message") }}
			<a :href="manualKeyLink" target="_blank" rel="noopener" class="service-banner__link">
				{{ $t("serviceBanner.linkLabel") }}
			</a>
		</span>
		<template v-slot:actions>
			<v-btn text @click="dismiss">{{ $t("serviceBanner.dismiss") }}</v-btn>
		</template>
	</v-banner>
</template>

<script>
// Link shown for manual key mode while the service is degraded. Update as needed.
const MANUAL_KEY_LINK = "https://help.iotee.eu/articles/manual-key-mode-recovery-mode-2";

export default {
	name: "ServiceBanner",
	data() {
		return {
			dismissed: false,
			manualKeyLink: MANUAL_KEY_LINK,
		};
	},
	computed: {
		showBanner() {
			return process.env.VUE_APP_SERVICE_OUTAGE === "true" && !this.dismissed;
		},
	},
	methods: {
		dismiss() {
			this.dismissed = true;
		},
	},
};
</script>

<style scoped>
.service-banner__message {
	white-space: pre-line;
	font-weight: 600;
}
.service-banner__link {
	color: inherit;
	font-weight: 600;
	text-decoration: underline;
}
</style>
